module.exports = __webpack_public_path__ + "static/motion-icon-1d2128d9092a292525122e25118b3dce.jpg";